import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-guides',
  imports: [RouterModule],
  templateUrl: './guides.component.html',
  styleUrl: './guides.component.css',
})
export class GuidesComponent {
  guides = [
    { emoji: '🚀', title: 'Démarrer avec Predivent', desc: 'Configuration initiale, import de vos premiers produits et événements.' },
    { emoji: '📅', title: 'Planifier ses événements', desc: 'Créer et gérer votre calendrier de marchés et événements.' },
    { emoji: '📊', title: 'Comprendre les prévisions', desc: 'Interpréter les recommandations de l\'algorithme.' },
    { emoji: '🌤️', title: 'Utiliser les données météo', desc: 'Comment la météo est intégrée dans vos prévisions.' },
    { emoji: '🔔', title: 'Configurer les notifications', desc: 'Recevoir les bonnes notifications au bon moment.' },
  ];
}